/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';

const VideoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeButton} onClick={onClose}>✖</button>
        <div style={{ padding: '56.25% 0 0 0', position: 'relative', width: '100%' }}>
          <iframe
            src="https://player.vimeo.com/video/1042726212?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="1"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            loading="lazy"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            title="DeepNode"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    position: 'relative',
    width: '80%',
    maxWidth: '800px',
    backgroundColor: '#000',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '-1%',
    right: '-1%',
    background: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '20px',
    cursor: 'pointer',
  },
};

export default VideoModal;
